{
  "colorSwatchPicker": "Vzorky barev",
  "dropzoneLabel": "Místo pro přetažení",
  "selectPlaceholder": "Vyberte položku",
  "tableResizer": "Změna velikosti"
}
